import LayoutNavigation from "../Components/Layout/LayoutNavigation";
import RegistrationDocumentsNavigationSection from "./RegistrationDocumentsNavigationSection";
import RootNavigationSection from "./RootNavigationSection";

export default () => {
	return (
		<LayoutNavigation>
			<RegistrationDocumentsNavigationSection />
			<RootNavigationSection />
		</LayoutNavigation>
	);
};
